import * as React from 'react';

import {appHistory} from '../../../history';

import {NewEditionModal} from '../editions/new-edition-modal';

import {TemplateMutations} from './template-mutations';

export const FAKE_TEMPLATE_ID = 'template';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    defaultView?: string;
};

export function NewTemplateModal(props: Props) {
    return (
        <TemplateMutations>
            {({onCreate, onDuplicate}) => (
                <NewEditionModal
                    // TODO: This is a hack to get flow to pass, but we don't technically
                    // need a campaignId here, so I'm hacking it.
                    campaignId={FAKE_TEMPLATE_ID}
                    type='campaignTemplates'
                    isOpen={props.isOpen}
                    onClose={props.onClose}
                    onCreateEdition={(name) => {
                        return onCreate(name).then((newTemplate) => {
                            if (newTemplate && newTemplate.edition) {
                                const edition = newTemplate.edition;

                                appHistory.push(edition.htmlUrlPath);
                            }
                        });
                    }}
                    onDuplicateEdition={(
                        editionId: string,
                        campaignId: string,
                        name?: string | null
                    ) => {
                        return onDuplicate(editionId, name).then((newTemplate) => {
                            if (newTemplate) {
                                const edition = newTemplate.edition;

                                appHistory.push(edition.htmlUrlPath);
                            }
                        });
                    }}
                    // @ts-expect-error
                    defaultView={props.defaultView}
                />
            )}
        </TemplateMutations>
    );
}
